"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.scrollTo = void 0;
var scrollTo = function (element) {
    var _a, _b;
    var elementToScrollTo = typeof element === "string" ? document.querySelector(element) : element;
    if (!elementToScrollTo) {
        return;
    }
    var publicHeaderSpacer = document.getElementById("public-header-spacer");
    var mode = !!publicHeaderSpacer ? "public" : "editor";
    if (mode === "editor") {
        elementToScrollTo.scrollIntoView({ behavior: "smooth" });
    }
    else {
        var offset = (_a = publicHeaderSpacer === null || publicHeaderSpacer === void 0 ? void 0 : publicHeaderSpacer.getBoundingClientRect().height) !== null && _a !== void 0 ? _a : 0;
        var elementTop = window.scrollY + ((_b = elementToScrollTo.getBoundingClientRect().top) !== null && _b !== void 0 ? _b : 0);
        window.scrollTo({ left: 0, top: elementTop - offset, behavior: "smooth" });
    }
    if (elementToScrollTo instanceof HTMLElement) {
        elementToScrollTo.focus({ preventScroll: true });
    }
};
exports.scrollTo = scrollTo;
